/**
 * @author: Real Links <engineering@reallinks.io> (https://real-links.github.io)
 * @license: © 2018 Real Links Limited
 * @link: https://real-links.github.io
 *
 * @TODO: Add other enums too? Pull these from GraphQL? Pull from the GraphQL schema?
 * @TODO: Get these values into i18n to be localised!
 */
import { locales } from '@src/i18n';

export default {
  computed: {
    contactRelevanceBoundaries: () => ({
      'VERY_STRONG': 80,
      'STRONG': 50,
      'AVERAGE': 30,
      'WEAK': 1,
    }),
    contactRelevanceLabels: () => ({
      'VERY_STRONG': 'Very Strong',
      'STRONG': 'Strong',
      'AVERAGE': 'Average',
      'WEAK': 'Weak',
    }),
    jobOrderByEnums: () => ({
      'CREATED_DESC': 'Newest first',
      'CREATED_ASC': 'Oldest first',
      // 'UPDATED_DESC': 'Recently updated',
      // 'UPDATED_ASC': 'Least updated',
      'MATCHES_DESC': 'Most matches',
      'MATCHES_ASC': 'Least matches',
      'BONUS_ASC': 'Has referral bonus',
      'MOST_RELEVANT': 'Most relevant',
      'RECENTLY_VIEWED': 'Recently viewed',
    }),
    internalJobOrderByEnums() {
      const { isInterestBasedMatching } = this.$root;
      const enums = {
        'CREATED_DESC': 'Newest first',
        'CREATED_ASC': 'Oldest first',
        'MOST_RELEVANT': 'Most relevant by skills',
        'RECENTLY_VIEWED': 'Recently viewed',
      };
      if (isInterestBasedMatching) {
        enums['MOST_RELEVANT_INTEREST'] = 'Most relevant by interest';
      }
      return enums;
    },
    projectOrderByEnums: () => ({
      'CREATED_DESC': 'Newest first',
      'CREATED_ASC': 'Oldest first',
      'UPDATED_DESC': 'Recently updated',
      'UPDATED_ASC': 'Least updated',
    }),
    userLocaleEnums() {
      const { locale } = this.$i18n;
      const { supportedLanguages } = this.$root;
      return Object.keys(locales).reduce((list, lang) => {
        if (Array.isArray(supportedLanguages) && supportedLanguages.includes(lang)) {
          const { labels } = locales[lang];
          list[lang] = `${labels[locale] || labels.en} (${lang})`;
        }
        return list;
      }, {});
    },
    userRoleEnums: () => ({
      // 'SUPER_ADMIN': 'Super Admin',
      'RECRUITER_ADMIN': 'Recruiter Admin',
      'RECRUITER': 'Recruiter',
      'EMPLOYEE': 'Employee',
      'ALUMNI': 'Alumni',
    }),
    userStatusEnums: () => ({
      'ACTIVE': 'Active',
      'INACTIVE': 'In-Active',
      'DELETED': 'Deleted',
    }),
    userOrderByEnums: () => ({
      CREATED_ASC: 'Oldest first',
      CREATED_DESC: 'Recently created',
      UPDATED_ASC: 'Oldest updated',
      UPDATED_DESC: 'Recently updated',
    }),
  },
};



// WEBPACK FOOTER //
// ./src/mixins/enums.js